import { match } from "css-mediaquery";
import { getDatabaseNamePath } from "../../app/config/config";

export function removeCSSClass(ele, cls) {
    const reg = new RegExp("(\\s|^)" + cls + "(\\s|$)");
    ele.className = ele.className.replace(reg, " ");
}

export function addCSSClass(ele, cls) {
    ele.classList.add(cls);
}


// export const toAbsoluteUrl = pathname => 
//     process.env.REACT_APP_PUBLIC_URL + pathname.replace('/media/', '/media/'+getDatabaseNamePath()+'/');

export function toAbsoluteUrl(pathname, division = null) {
    const divisionNames = ['valderma', 'roypet', 'roydermal'];
    const dbNamePath = division !== null ? getDivisionName(division) : getDatabaseNamePath();
    // Controlla se nel pathname è già presente un nome di divisione
    const hasDivisionInPath = divisionNames.some(name => pathname.includes(`/${name}/`));
    let resultPath = '';
    
    // Se il pathname contiene '/media/'
    if (pathname.includes('/media/')) {
        // Se non c'è già una divisione nel path, aggiungila
        let newPath = pathname;
        
        if (!hasDivisionInPath) {            
            newPath = pathname.replace('/media/', `/media/${dbNamePath}/`);
        }
        
        if (dbNamePath.toString() === "roydermal") {
            resultPath = process.env.REACT_APP_MEDIA_URL_ROYDERMAL + newPath;
        } else if (dbNamePath.toString() === "valderma") {                
            resultPath = process.env.REACT_APP_MEDIA_URL_VALDERMA + newPath;
        } else {
            resultPath = process.env.REACT_APP_MEDIA_URL_ROYDERMAL + newPath;
        }
        // } else {
        //     // Se c'è già un nome divisione, lascia il pathname così com'è
        //     return process.env.REACT_APP_MEDIA_URL + pathname;
        
    }
    console.log(resultPath);
    return resultPath;
}

function getDivisionName(division) {
    
    switch (Number(division)) {
        case 1:
            return "roypet";
        case 2:
            return "roydermal";
        case 11:
            return "valderma";
        default:
            return "roydermal";
    }
}